const menu = {
  label: '• Público Alvo',
  to: '/sol/publicoalvo',
  rules: ['SOL-001'],
}

export default menu;